import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReviewCheckoutModal from './ReviewCheckoutModal';
import { getSubscriptionType } from '../../utils';

import UpgradeAlert from './UpgradeAlert';
import SelectPlan from './SelectPlan';
import UpgradeSuccess from './UpgradeSuccess';

class PlanModal extends Component {
  constructor(props) {
    super();
    this.state = {
      step: 1,
      planType: 'free',
    };
  }

  componentWillMount() {
    const { showAllPlan, showCheckoutStep } = this.props;
    this.resetValues();

    if (showCheckoutStep) {
      this.setState({ step: 3 });
    } else {
      this.setState({ step: showAllPlan ? 2 : 1 });
    }
  }

  resetValues() {
    const { subscriptionPlan } = this.props;
    const { planType } = getSubscriptionType(subscriptionPlan, null);

    this.setState({
      originPlanType: planType,
      planType: planType,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.subscriptionPlan !== nextProps.subscriptionPlan) {
      const { planType } = getSubscriptionType(
        nextProps.subscriptionPlan,
        null
      );
      this.setState({
        originPlanType: planType,
        planType: planType,
      });
    }

    if (nextProps.showCheckoutStep) {
      this.setState({ step: 3 });
    }
  }

  handlePurchase() {
    this.props.hidePlanModal(true);
  }

  handleViewOptions() {
    this.resetValues();
    this.setState({ step: 2 });
  }

  hidePlanModal() {
    this.props.hidePlanModal(false);
  }

  exitedPlanModal() {
    const { showAllPlan } = this.props;
    this.resetValues();
    this.setState({ step: showAllPlan ? 2 : 1 });
  }

  handlePlan = (type) => {
    this.setState({
      step: 3,
      planType: type,
    });
  };

  handlePaySuccess() {
    this.setState({ step: 4 });
  }

  render() {
    const {
      show,
      agreementType,
      referrer,
      showAllPlan,
      showCheckoutStep,
      isPremiumExpired,
      isCanceledSubscription,
      handleFreeDowngrade,
      subscriptionPlan,
    } = this.props;
    const { step, planType, originPlanType } = this.state;

    if (step === 1) {
      return (
        <UpgradeAlert
          show={show}
          agreementType={agreementType}
          referrer={referrer}
          planType={planType}
          hidePlanModal={() => this.hidePlanModal()}
          exitedPlanModal={() => this.exitedPlanModal()}
          handlePurchase={() => this.handlePurchase()}
          handleViewOptions={() => this.handleViewOptions()}
        />
      );
    } else if (step === 2) {
      return (
        <SelectPlan
          show={show}
          referrer={referrer}
          originPlanType={originPlanType}
          subscriptionPlan={subscriptionPlan}
          showAllPlan={showAllPlan}
          showCheckoutStep={showCheckoutStep}
          isPremiumExpired={isPremiumExpired}
          isCanceledSubscription={isCanceledSubscription}
          handleFreeDowngrade={handleFreeDowngrade}
          handlePlan={(type) => this.handlePlan(type)}
          hidePlanModal={() => this.hidePlanModal()}
          exitedPlanModal={() => this.exitedPlanModal()}
        />
      );
    } else if (step === 3) {
      return (
        <ReviewCheckoutModal
          show={show}
          referrer={referrer}
          planType={planType}
          onHide={() => this.hidePlanModal()}
          onExited={() => this.exitedPlanModal()}
          onCancel={() => this.hidePlanModal()}
          onBack={() => this.handleViewOptions()}
          onPaySuccess={() => this.handlePaySuccess()}
        />
      );
    } else {
      let planText = 'Free Plan';

      if (planType !== 'free') {
        planText = planText.toUpperCase();
      }

      return (
        <UpgradeSuccess
          show={show}
          planText={planText}
          exitedPlanModal={() => this.exitedPlanModal()}
          hidePlanModal={() => this.hidePlanModal()}
        />
      );
    }
  }
}

PlanModal.defaultProps = {
  referrer: '',
  showAllPlan: false,
  showCheckoutStep: false,
  isPremiumExpired: false,
  agreementType: -1,
  isCanceledSubscription: false,
  handleFreeDowngrade: () => {},
};

PlanModal.propTypes = {
  referrer: PropTypes.string,
  showAllPlan: PropTypes.bool,
  showCheckoutStep: PropTypes.bool,
  isPremiumExpired: PropTypes.bool,
  isCanceledSubscription: PropTypes.bool,
  handleFreeDowngrade: PropTypes.func,
};

export default PlanModal;



// WEBPACK FOOTER //
// src/components/UserPlan/PlanModal.jsx